import { get, post } from '../index'

export default {
  // 获取动态列表
  getDynamicList (querys) {
    return get('/dynamic/timeline', querys)
  },
  // 上下架或删除动态信息
  updateDynamicInfo (querys) {
    return post('/dynamic/updateTimelines', querys)
  },
  // 添加动态信息
  addDynamicInfo (querys) {
    return post('/dynamic/adminCreateLine', querys)
  },
  // 修改动态信息
  modifyDynamicInfo (querys) {
    return post('/dynamic/updateLine', querys)
  },
  // 动态表单回显
  getDynamicFormInfo (querys) {
    return get('/dynamic/timelineInfo', querys)
  },
  // 获取评论列表
  getCommoentList (querys) {
    return get('/dynamic/commentList', querys)
  },
  // 删除评论
  delCommentInfo (querys) {
    return post('/dynamic/commentDel', querys)
  },
  // 获取员工列表
  getDynamicStaffInfo (querys) {
    return post('/dynamic/AdminOfficer/getStaffInfo', querys)
  },
  // 获取公司列表
  getDynamicCompanyInfo (querys) {
    return post('/dynamic/AdminOfficer/getCompanyInfo', querys)
  },
  // 获取员工发布动态权限
  staffDynamic (querys) {
    return post('/dynamic/AdminOfficer/staffDynamic', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/dynamic.js